import { render, staticRenderFns } from "./ReleaseList.vue?vue&type=template&id=b5e3eaaa&scoped=true"
import script from "./ReleaseList.vue?vue&type=script&lang=js"
export * from "./ReleaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e3eaaa",
  null
  
)

export default component.exports